enum Breakpoints {
  xs = 375,
  sm = 680,
  mm = 850,
  md = 1020,
  lg = 1280,
  xl = 1920,
}

export type BreakpointsKeys = keyof typeof Breakpoints;

export default Breakpoints;
